import '../../App.css';
import { useContext, useEffect } from "react";
import { Form, Row, Col, Tabs, Tab } from 'react-bootstrap';
import { FaTimes } from 'react-icons/fa';
import { StyleContext } from '../../context/StyleContext';
import { ApiContext } from '../../context/ApiContext';
import { ServicoContext } from '../../context/ServicoContext';

function ModalCadastrarSistema({ closeModal, currentPage }) {
    const { CadastrarSistema, CadastroSistema, setCadastroSistema, ListarImpactoNegocio, ImpactoNegocio } = useContext(ApiContext)
    const { ListaFornecedor, Fornecedores } = useContext(ServicoContext)
    const { btnVer, btnCriar } = useContext(StyleContext)

    const handleChange = (event) => {
        setCadastroSistema({ ...CadastroSistema, [event.target.name]: event.target.value })
    }

    useEffect(() => {
        ListaFornecedor()
        ListarImpactoNegocio()
    }, [])

    return (
        <div className="modal-novo">
            <div className="modal-novo-interno">
                <div className="header-modal">
                    <h1 className="h1-modal">Cadastrar sistema</h1>
                    <div className="btn-close-modal" onClick={() => closeModal(false)}>
                        <FaTimes />
                    </div>
                </div>
                <form onSubmit={(e) => CadastrarSistema(e, currentPage)}>
                    <div className="modal-content">
                        <Row>
                            <Col xs={12}>
                                <Form.Group className="mb-3">
                                    <Form.Label>Sistema</Form.Label>
                                    <Form.Control maxLength={255} onChange={handleChange} name="nome" />
                                </Form.Group>
                            </Col>

                        </Row>
                        <Row>
                            <Col xs={4}>
                                <Form.Group className="mb-3">
                                    <Form.Label>Versão</Form.Label>
                                    <Form.Control maxLength={100} onChange={handleChange} name="versao" />
                                </Form.Group>
                            </Col>
                            <Col xs={4}>
                                <Form.Group className="mb-3">
                                    <Form.Label>Data Inicial Versão</Form.Label>
                                    <Form.Control type='date' defaultValue={new Date("01/01/0001")} onChange={handleChange} name="dataInicialVersao" />
                                </Form.Group>
                            </Col>
                            <Col xs={4}>
                                <Form.Group className="mb-3">
                                    <Form.Label>Data Final Versão</Form.Label>
                                    <Form.Control type='date' defaultValue={new Date("01/01/0001")} onChange={handleChange} name="dataFinalVersao" />
                                </Form.Group>
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={6}>
                                <Form.Group className="mb-3">
                                    <Form.Label>Camada de Impacto no Negócio</Form.Label>
                                    <Form.Select aria-label="Default select example" onChange={handleChange} name="camadaImpactoNegocio">
                                        <option value="0">Selecione</option>
                                        {ImpactoNegocio &&
                                            ImpactoNegocio?.map((item) => {
                                                return (
                                                    <option key={item} value={item}>{item}</option>
                                                )
                                            })

                                        }
                                    </Form.Select>
                                </Form.Group>
                            </Col>
                            <Col xs={6}>
                                <Form.Group className="mb-3">
                                    <Form.Label>Fornecedor</Form.Label>
                                    <Form.Select aria-label="Default select example" onChange={handleChange} name="fornecedorKey">
                                        <option value="0">Selecione</option>
                                        {Fornecedores &&
                                            Fornecedores?.map((item) => {
                                                return (
                                                    <option key={item.id} value={item.key}>{item.fantasia}</option>
                                                )
                                            })

                                        }
                                    </Form.Select>
                                </Form.Group>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Form.Group className="mb-3">
                                    <Form.Label>Descrição</Form.Label>
                                    <Form.Control maxLength={255} onChange={handleChange} name="descricao" as="textarea" rows={3} />
                                </Form.Group>
                            </Col>
                        </Row>
                    </div>
                    <div className="footer-modal-criar-demanda">
                        <button type="button" className="btn-dash btn-ver" style={btnVer} onClick={() => closeModal(false)}>Cancelar</button>
                        <button className="btn-dash btn-criar" style={btnCriar}>Salvar</button>
                    </div>
                </form>
            </div>
        </div>
    )
}

export default ModalCadastrarSistema